/**
 * Cross-cutting bus: apiClient notifies when BE returns ADMIN_STEP_UP_REQUIRED
 * so a global StepUpChallengeDialog can open on D′ mutate surfaces (not MFA-only).
 */

type AdminStepUpRequiredListener = () => void;

const listeners = new Set<AdminStepUpRequiredListener>();

/** Fire when a response carries a step-up-required error code (typically HTTP 403). */
export function notifyAdminStepUpRequired(): void {
  for (const listener of listeners) {
    listener();
  }
}

declare global {
  interface Window {
    /** Dev/e2e + TP04 capture — same bus as apiClient step-up gate. */
    __adminNotifyStepUpRequired?: () => void;
  }
}

if (typeof window !== 'undefined' && process.env.NODE_ENV !== 'production') {
  window.__adminNotifyStepUpRequired = notifyAdminStepUpRequired;
}

/** Subscribe; returns unsubscribe. */
export function subscribeAdminStepUpRequired(
  listener: AdminStepUpRequiredListener,
): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}
